"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calcMinDate = void 0;

var _addDays = _interopRequireDefault(require("date-fns/addDays"));

var _constants = require("./constants");

var _constants2 = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* Минимальная дата для выбора в календаре */
var calcMinDate = function calcMinDate(searchType) {
  /*
   * Внимание!
   * Тут необходимо брать модуль от часов, потому что по UTC полночь это 21:00:00 и если делать + 3 то просто будет 24, что некорректно
   * должно быть 0 и тогда равенство будет работать корректно
   */
  var isEvening = (new Date().getUTCHours() + _constants.OFFSET_TIMEZONE_MSK) % 24 >= _constants.START_EVENING_HOUR;

  var now = new Date();
  var currentDayMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
  var minDateTour = (0, _addDays["default"])(currentDayMidnight, isEvening ? 2 : 1);
  var minDate = searchType === _constants2.SEARCH_TYPE_NAMES.PACKAGE ? minDateTour : currentDayMidnight;
  return minDate;
};

exports.calcMinDate = calcMinDate;